import React from "react";
import { FiArrowLeft } from "react-icons/fi";
import { useHistory } from "react-router-dom";

import logoCorreios from "../../assets/correios-logo-white.png";
import * as Styles from "./styles";

export function Header({ hideBackButton }) {
  const { goBack } = useHistory();

  return (
    <Styles.Header>
      {hideBackButton ? (
        <p />
      ) : (
        <button onClick={goBack}>
          <FiArrowLeft size={24} />
        </button>
      )}
      <img src={logoCorreios} alt="Logo Mvno" />
    </Styles.Header>
  );
}
